var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ypoErrorData)?_c('v-flex',{staticClass:"ypo-error-page",domProps:{"innerHTML":_vm._s(_vm.ypoErrorData)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }